var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingAntibiotic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12861_3638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2811 14.8812L17.7893 11.168L14.1154 10.25H8.58838V12.6853C9.40586 13.0372 10.1153 13.7145 10.6836 14.3304C11.7504 15.4837 12.1369 16.5855 12.1369 18C12.1369 19.1266 11.8171 19.9416 11.3527 20.7949C11.9546 21.0248 12.801 21.1583 13.4347 21.1583C16.0815 21.1583 18.2811 18.8095 18.2811 15.8987V14.8812Z",
    fill: "#FF9A9A",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58838 10.75H14.1039L17.4058 9.60013L18.2811 6.42491V5.49488C18.2811 2.80211 16.0973 0.60157 13.4347 0.60157C10.7721 0.60157 8.58838 2.8021 8.58838 5.49488V6.57051V10.75Z",
    fill: "#FF9A9A",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5088 14.0197C9.9053 13.4162 9.16477 12.948 8.33846 12.6663C7.76546 12.4701 7.14948 12.3652 6.50865 12.3652C3.38607 12.3652 0.854492 14.8911 0.854492 18.0068C0.854492 21.1224 3.38607 23.6483 6.50865 23.6483C8.55024 23.6483 10.3385 22.5697 11.3323 20.9525C11.8597 20.0949 12.1642 19.0867 12.1642 18.0068C12.1642 16.4503 11.5316 15.0402 10.5088 14.0197Z",
    fill: "#F9F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.391 12.5297H16.9904V15.1247C16.9904 15.2587 17.1011 15.3691 17.2354 15.3691H18.5309H20.0548C20.1905 15.3691 20.2998 15.2587 20.2998 15.1247V12.5297H22.9006C23.0349 12.5297 23.1456 12.4206 23.1456 12.2866V9.47344C23.1456 9.33811 23.0349 9.22898 22.9006 9.22898H20.2998V6.63398C20.2998 6.50002 20.1905 6.38953 20.0548 6.38953H18.5309H17.2354C17.1011 6.38953 16.9904 6.50002 16.9904 6.63398V9.22898H14.391C14.2568 9.22898 14.146 9.33811 14.146 9.47344V10.8793V12.2866C14.146 12.4206 14.2568 12.5297 14.391 12.5297Z",
    fill: "#F23B53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.15738C14.0784 1.71946 15.6261 3.71919 15.6261 6.08497V9.25269H16.7686L17 7.5C17 7.36603 16.8732 6.5 17 6.5H18V6.08497C18 2.5 16.1739 0.999982 13 0.999982C12.5908 0.999982 12.3804 1.05379 12 1.15738Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9194 12.7669L15.8574 12.7078L15.6259 16.4183C15.6259 18.5487 14.3914 20.3517 12.313 20.8582C12.6934 20.9502 13.5908 21 13.9999 21C15.6259 20.9422 18.0813 18.9381 18.0813 16.4183V15.5585H17.1508C17.024 15.5585 16.9194 15.4589 16.9194 15.3382V12.7669Z",
    fill: "#60B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2358 6.38946H20.0553C20.1909 6.38946 20.3003 6.49994 20.3003 6.63391V9.22891H22.901C23.0353 9.22891 23.1461 9.33799 23.1461 9.47336V12.2865C23.1461 12.4205 23.0353 12.5296 22.901 12.5296H20.3003V15.1246C20.3003 15.2586 20.1909 15.369 20.0553 15.369H17.2358C17.1016 15.369 16.9908 15.2586 16.9908 15.1246V12.5296H14.3915C14.2572 12.5296 14.1465 12.4205 14.1465 12.2865V9.47336C14.1465 9.33799 14.2572 9.22891 14.3915 9.22891H16.9908V6.63391C16.9908 6.49994 17.1016 6.38946 17.2358 6.38946Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16748 14.7974H7.1787",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23389 17.286H9.24511",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36377 21.407H5.37499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76758 17.5538H2.7788",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32884 18.5068C7.66308 17.9586 6.19176 18.3743 5.90386 16.2612C5.73501 15.0308 3.63942 15.1965 4.38408 17.2376C4.93495 18.7458 5.68237 19.4446 7.1288 19.9183C8.6887 20.4306 8.99184 19.0537 8.32884 18.5068Z",
    fill: "#A7E9A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9458 12.5835C7.88707 12.7824 10.211 15.2268 10.211 18.2126C10.211 20.7869 8.48088 22.9593 6.11814 23.636C6.24686 23.6443 6.37699 23.6484 6.50847 23.6484C8.55007 23.6484 10.3383 22.5698 11.3321 20.9527C11.8595 20.095 12.164 19.0868 12.164 18.0069C12.164 16.4505 11.5315 15.0404 10.5086 14.0198C9.90513 13.4163 9.1646 12.9481 8.33829 12.6664C7.76524 12.4717 7.1493 12.3653 6.50847 12.3653C5.96589 12.3653 5.44132 12.4412 4.9458 12.5835Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50865 23.6484C9.62293 23.6484 12.1642 21.1142 12.1642 18.0068C12.1642 14.8995 9.62293 12.3653 6.50865 12.3653C3.39437 12.3653 0.854492 14.8995 0.854492 18.0068C0.854492 21.1142 3.39437 23.6484 6.50865 23.6484Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52441 13.9493H5.53564",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22675 16.7542C5.51602 18.8686 6.98738 18.4529 7.65174 19.0012C7.95764 19.2525 8.0573 19.6806 7.92441 20.0204C8.77149 19.9057 8.85732 18.9432 8.32857 18.5067C7.6628 17.9584 6.19149 18.3742 5.90358 16.2612C5.78039 15.3635 4.63435 15.2088 4.30908 15.9808C4.71877 15.9504 5.15339 16.2211 5.22675 16.7542Z",
    fill: "#7FDBAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1288 19.9183C5.68242 19.4446 4.93495 18.7458 4.38408 17.2376C3.63942 15.1965 5.73501 15.0308 5.90386 16.2612C6.19176 18.3743 7.66308 17.9586 8.32884 18.5068C8.99184 19.0538 8.6887 20.4306 7.1288 19.9183Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06445 21.4954L10.509 14.0198",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90088 21.407H7.9121",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12861_3638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingAntibiotic);
export default __webpack_public_path__ + "static/media/Pending Antibiotic.d7c196f417a6c4d643548007f04eda59.svg";
export { ForwardRef as ReactComponent };